__webpack_require__.p = "/mi-assets/mi-static/mi-shop-renderer-2/web-rel-26.10.1-100620261030/_next/";